var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaireferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 475.794,
    height: 480,
    viewBox: "0 0 475.794 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.9,336l22.72-32L53.9,272l32-32V472h48V336h72v56h48V320a32,32,0,0,0-32-32h-56V232l112-80-24-32-104,72-24,48-24-48h-32l-51.68,57.44a32,32,0,0,0,1.12,44Z",
    fill: "#f29b23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.9,192h-48l24,48Z",
    fill: "#ef9f35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    transform: "translate(69.897 96)",
    fill: "#f29b23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.9,392v80h160V392h-160Z",
    fill: "#ef9f35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.657,24.88a64,64,0,0,1-44.88,44.88,2.32,2.32,0,0,0,0,4.48,64,64,0,0,1,44.88,44.88,2.32,2.32,0,0,0,4.48,0,64,64,0,0,1,44.88-44.88,2.32,2.32,0,0,0,0-4.48,64,64,0,0,1-44.88-44.88,2.32,2.32,0,0,0-4.48,0Z",
    fill: "#f7d04f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.217,341.68a8.049,8.049,0,0,0,12.24-1.04l9.44-13.36V472a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8V344h56v40h-24a8,8,0,0,0-8,8v80a8,8,0,0,0,8,8h160a8,8,0,0,0,8-8V392a8,8,0,0,0-8-8h-72V320a40,40,0,0,0-40-40h-48V236.08l108.64-77.6a7.927,7.927,0,0,0,1.76-11.28l-24-32a8,8,0,0,0-10.96-1.76l-82,56.72A56,56,0,1,0,78.778,184H69.9a8,8,0,0,0-5.92,2.64L12.3,244.08a40,40,0,0,0,1.6,55.04Zm21.68-56L65.1,272l12.8-12.8ZM325.9,464h-144V400h144ZM136.937,200,125.9,222.08,114.857,200ZM77.9,144a40,40,0,1,1,40,40A40,40,0,0,1,77.9,144ZM24.137,254.8,73.5,200h23.44l21.84,43.6a8,8,0,0,0,14.24,0l23.12-46.16,96-66.48,14.48,19.28-105.36,75.28A8,8,0,0,0,157.9,232v56a8,8,0,0,0,8,8h56a24,24,0,0,1,24,24v64h-32V336a8,8,0,0,0-8-8h-72a8,8,0,0,0-8,8V464h-32V240a8.05,8.05,0,0,0-13.68-5.68l-32,32a8,8,0,0,0,0,11.2l26.16,27.28-13.52,18.88L25.017,288a24,24,0,0,1-.88-33.2Z",
    fill: "#3c3c48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.9,64a56,56,0,0,1-56-56,8,8,0,0,0-16,0,56,56,0,0,1-56,56,8,8,0,0,0,0,16,56,56,0,0,1,56,56,8,8,0,0,0,16,0,56,56,0,0,1,56-56,8,8,0,0,0,0-16Zm-64,39.04A72.632,72.632,0,0,0,374.857,72,72.643,72.643,0,0,0,405.9,40.96,72.643,72.643,0,0,0,436.937,72,72.643,72.643,0,0,0,405.9,103.04Z",
    fill: "#3c3c48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.174,217.527l21.806-15.989,9.461,12.9L258.635,230.43Z",
    fill: "#3c3c48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.222,188.233,369.2,129.547l9.465,12.9-79.979,58.686Z",
    fill: "#3c3c48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.441,121.327l47.993-32,8.875,13.313L298.316,134.64Z",
    fill: "#3c3c48"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaireferral);
export default __webpack_public_path__ + "static/media/caireferral.a2557100255c9ca1240b406d06170b50.svg";
export { ForwardRef as ReactComponent };